import { useTranslation } from 'react-i18next';

import { PngIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './LeaveProductPopup.module.css';

type LeaveProductPopup = {
  onPrimary: () => void;
  onCancel: () => void;
};
export const LeaveProductPopup = (props: LeaveProductPopup) => {
  const { onPrimary, onCancel } = props;
  const { t } = useTranslation();
  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPrimary}
      primaryButtonLabel={t('OK')}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          {<PngIcon name="Notice" width={80} height={80} />}
        </div>
        <div className={styles.titleContainer}>
          <p className={styles.title} />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.text}>
            {t(`You will lose the referral price.`)}
          </div>
          <div className={styles.text}>
            {t('Are you sure you want to leave?')}
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
